import React from 'react';
import { Typography, Link, Box, Grid } from '@mui/material';
import { useSelector } from 'react-redux';

const Footer = () => {
  const customizer = useSelector((state) => state.customizer);
  return (
    <footer>
      <br /><br />
      <Box
        sx={{
          background: customizer.activeMode === 'light' ? '#FFF2D7' : customizer.darkBackground900,
          padding: '10px', // Spacing around content
          color: customizer.activeMode === 'light' ? '#000' : '#FFF2D7',
          width: '100%',
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', sm: 'row' }, // Column on small screens, row on larger screens
            textAlign: { xs: 'center', sm: 'left' }, // Center text on small screens
          }}
        >
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" sx={{ fontSize: '14px' }}>
              Copyright &copy; {new Date().getFullYear()} Sastraprakasika Trust. All Rights
              Reserved.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} sx={{ textAlign: { xs: 'center', sm: 'right' } }}>
            <Typography variant="body2" sx={{ fontSize: '12px' }}>
              Developed by{' '}
              <Link
                href="https://www.imaginetventures.com"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: '#ff6d00', fontWeight: 'bold', textDecoration: 'none' }} // Gold color for the link
              >
                ImagiNET Ventures
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </footer>
  );
};

export default Footer;
